var login_ajax = require( './login-ajax' );

var login_modal = (function( $ ) {

	/**
	 * An array of all members zone page urls
	 */
	var urls;

	/**
	 * Contains the last members zone anchor tag clicked
	 */
	var $current_anchor;

	/**
	 * Contains the jQuery object representing the modal
	 */
	var $modal;

	/**
	 * Contains the jQuery object representing the form
	 */
	var $form;

	var _init = function() {
		urls = ScriptData.member_pages;
		$modal = $( '#login-modal' );
		$form = $modal.find( '#login-modal-form' );

		if ( ScriptData.sso ) {
			urls.push( ScriptData.sso );
			$( 'body' ).append(
				$( '<a class="sso-anchor" style="display: none; pointer-events: none;" href="' + ScriptData.sso + '">sso</a>' )
			);
		}

		_attach_anchor_handlers();
		_attach_modal_handlers();

		if ( ScriptData.sso ) {
			if ( $( '#login-modal-form' ).length < 1 ) {
				$( '.sso-anchor' ).trigger( 'click' );
			} else {
				$current_anchor = $( '.sso-anchor' );
			}
		}
	};

	var _attach_anchor_handlers = function() {
		$( 'a.login-popup' ).on( 'click', _maybe_show_modal );

		for ( var url in urls ) {
			if ( urls.hasOwnProperty( url ) ) {
				_attach_anchor_handler( $( 'a[href*="' + urls[url] + '"]' ) );
			}
		}
	};

	var _attach_anchor_handler = function($anchor) {
		$anchor.on( 'click', _maybe_show_modal );
	};

	var _detach_anchor_handler = function($anchor ) {
		$anchor.off( 'click', _maybe_show_modal );
	}

	var _attach_modal_handlers = function() {
		$modal.find( '.close-modal' ).on( 'click', _close_modal );
		$modal.find( '#login-modal-form').on( 'submit', _login );
	};

	var _maybe_show_modal = function( e ) {
		e.preventDefault();

		$current_anchor = $( this );

		var data = {
			action : 'is_auth_for_members_zone',
			is_auth_nonce  : ScriptData.is_auth_nonce
		};

		$.post( ScriptData.ajaxurl, data, _maybe_show_modal_response );
	};

	var _maybe_show_modal_response = function( response ) {
		if ( ! response.is_auth ) {
			show_modal();
		} else {
			_detach_anchor_handler( $current_anchor );
			$current_anchor[0].click();
		}
	};

	var show_modal = function() {
		var $popup = $current_anchor.closest( '.crate-popup' );

		if ( $popup.length > 0 ) {
			$popup.find( '.close-popup' ).trigger( 'click' );
		}

		$( 'body' ).addClass( 'login-modal-open' );
		$modal.addClass( 'open' );
	};

	var _close_modal = function (e) {
		$( 'body' ).removeClass( 'login-modal-open' );
		$modal.removeClass( 'open' );

		e.preventDefault();
	};

	var _login = function( e ) {
		e.preventDefault();

		login_ajax.loading( $modal );

		login_ajax.login( $form, _login_response, $current_anchor.attr( 'href' ) );
	};

	var _login_response = function( response ) {
		login_ajax.loaded( $modal );

		if ( !response.can_view.content ) {
			var message = "We have not found your login details. Please try again, or perhaps you want to <a href='https://esra.multiregistration.com/login?lost_password=1'>reset your password?</a>";

			if ( 'expired_member' === response.userDetails.status_description ) {
				message = "It looks like your membership has expired, please <a href='https://esra.multiregistration.com/' target='_blank'>renew your membership</a> before logging in.";
			}

			$modal.find( '.notice' ).html( message ).fadeIn();
		} else {
			$modal.find( '.notice' ).html( 'You are now logged in... redirecting...' ).fadeIn();

			if ( typeof response.sso_redirect !== 'undefined' ) {
				$current_anchor.attr( 'href', response.sso_redirect );
			}

			_detach_anchor_handler( $current_anchor );
			$current_anchor[0].click();
		}
	};

	$( document ).ready( _init );

	return {
		show_modal: show_modal
	};

})( jQuery );

module.exports = login_modal;